/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { Components } from './components';
import { ReleaseStateEnum } from './releaseStateEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseSpec { 
    /**
     * Add release to the upgradeFrom list
     */
    add_to_upgrade_from?: string;
    components?: Components;
    /**
     * Comments/Notes regarding this release
     */
    notes?: string;
    release_type: ReleaseTypeEnum;
    /**
     * Remove release from the upgradeFrom list
     */
    remove_from_upgrade_from?: string;
    service_type: ServiceTypeEnum;
    cloud_provider?: CloudProviderEnum;
    /**
     * If true (default false), skip some validation to load this release in SaaSInfra.
     */
    skip_validation?: boolean;
    state?: ReleaseStateEnum;
    /**
     * Check and update the deployment\'s upgrade status
     */
    update_upgrade_status?: boolean;
    /**
     * Version String for a release
     */
    version: string;
}
export namespace UpdateReleaseSpec {
}


